export default __webpack_public_path__ + "static/media/noots.cea0888a.png";